import React from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import {
  deleteBriefProject,
  getBriefProject,
} from '@disco/state-management/reducers/entities/briefProjects'
import { Dialog, Button as DsButton, Flex as DsFlex } from 'components/ds'

interface DeleteProjectDialogProps {
  onOpenChange: (open: boolean) => void
  briefProjectId?: string
}

const DeleteProjectDialog: React.FC<DeleteProjectDialogProps> = ({
  onOpenChange,
  briefProjectId,
}) => {
  const dispatch = useDispatch()
  const briefProject = useSelector(state =>
    briefProjectId
      ? getBriefProject(state, { briefProjectId: Number(briefProjectId) })
      : undefined,
  )

  const isDeleting = briefProject?.deleting || false

  const handleConfirm = async () => {
    if (briefProjectId) {
      try {
        await dispatch(deleteBriefProject(Number(briefProjectId))).unwrap()
        onOpenChange(false)
      } catch (error) {
        // Error is handled by Redux action, dialog stays open
      }
    }
  }

  return (
    <Dialog.Root defaultOpen onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="450px">
        <Dialog.Title>Are you sure you want to delete?</Dialog.Title>
        <Dialog.Description>
          Deleting a project will also delete any corresponding briefs and their
          responses.
        </Dialog.Description>

        <DsFlex gap="3" mt="4" justify="end">
          <Dialog.Close>
            <DsButton
              variant="soft"
              color="gray"
              size="2"
              disabled={isDeleting}
            >
              Cancel
            </DsButton>
          </Dialog.Close>
          <DsButton
            variant="solid"
            color="red"
            size="2"
            onClick={handleConfirm}
            disabled={isDeleting}
            loading={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </DsButton>
        </DsFlex>
      </Dialog.Content>
    </Dialog.Root>
  )
}

export default DeleteProjectDialog
